import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import './LoadingState.css';

export default function LoadingState (props) {
  const { isLoading, loadingIcon, description } = props;

  if (!isLoading) {
    return null;
  }

  return (
    <div className={isLoading ? 'loadingState visible' : 'loadingState hidden'}>
      <Avatar aria-label="loading-state">
        {loadingIcon}
      </Avatar>
      <CircularProgress thickness={2.5} className='loadingProgress' />
      <Typography component="h2" className="header">{description}</Typography>
    </div>
  );
}

LoadingState.propTypes = {
  isLoading: PropTypes.bool,
  loadingIcon: PropTypes.object,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
